import React from 'react';
import Period from './Period/Period';
import Status from './Status/Status';

const Filters = ({ generateParams }) => {
    return (
        <div className='filters'>
            <Status generateParams={generateParams} />
            <Period generateParams={generateParams} />
        </div>
    );
};

export default Filters;
